// Source of truth: src/layouts/AppLayout/index.module.scss (grid-template-rows: 60px auto)
// Confirmed by: @pulsarml/avalon-ui Header component (tw-h-[60px] internally)

/** Height of the Avalon UI Header / AppTopBar in pixels. */
export const HEADER_HEIGHT_PX = 60;
